import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Heart, Sparkles } from "lucide-react";
import { endpoints, api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Cars() {
  const [cats, setCats] = useState([]);
  const [cars, setCars] = useState([]);
  const [active, setActive] = useState("");
  const [myVotes, setMyVotes] = useState({});
  const { user, login } = useAuth();

  const load = () => {
    endpoints.cars(active ? { category_id: active } : {}).then(setCars).catch(() => {});
  };
  useEffect(() => { endpoints.categories().then(setCats).catch(() => {}); }, []);
  useEffect(() => { load(); }, [active]);
  useEffect(() => { if (user) api.get("/my-votes").then((r) => setMyVotes(r.data)).catch(() => {}); }, [user]);

  const vote = async (car) => {
    if (!user) return login();
    try {
      const res = await api.post(`/cars/${car.id}/vote`);
      toast.success(res.data.message);
      const mv = { ...myVotes };
      if (res.data.voted) mv[car.category_id] = car.id; else delete mv[car.category_id];
      setMyVotes(mv);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not vote");
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="font-display text-4xl uppercase text-white">Cars & Voting</h1>
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1" data-testid="category-filter">
        <button onClick={() => setActive("")} className={`shrink-0 px-4 py-2 font-heading uppercase text-xs border ${active === "" ? "pas-gradient text-black border-transparent" : "border-white/15 text-white/70"}`}>All</button>
        {cats.map((c) => (
          <button key={c.id} onClick={() => setActive(c.id)} data-testid={`cat-${c.id}`}
            className={`shrink-0 px-4 py-2 font-heading uppercase text-xs border ${active === c.id ? "pas-gradient text-black border-transparent" : "border-white/15 text-white/70"}`}>
            {c.name}{c.locked && " 🔒"}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {cars.map((car) => {
          const voted = myVotes[car.category_id] === car.id;
          return (
            <div key={car.id} className="border border-white/10 bg-[#121212] overflow-hidden card-hover" data-testid={`car-${car.id}`}>
              <Link to={`/app/cars/${car.id}`} className="block aspect-[4/3] overflow-hidden relative">
                <img src={car.photo_url} alt={`${car.make} ${car.model}`} className="w-full h-full object-cover" />
                {car.status === "winner" && <span className="absolute top-2 left-2 pas-gradient text-black font-heading uppercase text-xs px-2 py-1">Winner</span>}
                {car.is_ai_generated && <span className="absolute top-2 right-2 bg-black/70 text-[#b026ff] text-[10px] font-heading uppercase px-2 py-1 flex items-center gap-1"><Sparkles size={10} /> AI</span>}
              </Link>
              <div className="p-4">
                <div className="text-[#ff7a1a] font-heading text-xs uppercase">{car.year} · {car.category_name}</div>
                <Link to={`/app/cars/${car.id}`} className="font-heading text-lg text-white uppercase leading-tight block">{car.make} {car.model}</Link>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-[#8a8d91] text-sm flex items-center gap-1"><Trophy size={13} /> {car.vote_count}</span>
                  <button onClick={() => vote(car)} data-testid={`vote-${car.id}`}
                    className={`px-4 py-2 font-heading uppercase text-xs flex items-center gap-1.5 transition-all ${voted ? "pas-gradient text-black" : "border border-[#b026ff] text-[#b026ff] hover:bg-[#b026ff]/10"}`}>
                    <Heart size={13} fill={voted ? "currentColor" : "none"} /> {voted ? "Voted" : "Vote"}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
